import { render, staticRenderFns } from "./LazyEditor.vue?vue&type=template&id=12ad697e&scoped=true&"
import script from "./LazyEditor.vue?vue&type=script&lang=js&"
export * from "./LazyEditor.vue?vue&type=script&lang=js&"
import style0 from "./LazyEditor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LazyEditor.vue?vue&type=style&index=1&id=12ad697e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ad697e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
